import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { EnrollmentManagementForm } from '@/features/student-management/ui/organisms/EnrollmentManagementForm';
import { EnrollmentManagementTemplate } from '@/features/student-management/ui/templates/EnrollmentManagementTemplate';

export const Route = createFileRoute('/_authenticated/enrollments/$enrollmentId/')({
  component: EnrollmentManagementPage,
});

function EnrollmentManagementPage() {
  const { enrollmentId } = Route.useParams();
  const navigate = useNavigate();

  return (
    <EnrollmentManagementTemplate>
      <EnrollmentManagementForm
        enrollmentId={Number(enrollmentId)}
        onBack={() => navigate({ to: '/enrollments' })}
      />
    </EnrollmentManagementTemplate>
  );
}
